import React from 'react';
import { animated, useSpring } from 'react-spring';

interface Props {
  rotation?: number;
  timing?: number;
  children: React.ReactNode;
}

const Boop = ({ rotation = 0, timing = 150, children }: Props) => {
  const [isBooped, setIsBooped] = React.useState(false);

  const style = useSpring({
    transform: isBooped ? `rotate(${rotation}deg)` : `rotate(0deg)`,
    config: {
      tension: 300,
      friction: 10,
    },
  });

  React.useEffect(() => {
    if (!isBooped) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsBooped(false);
    }, timing);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isBooped, timing]);

  const trigger = () => {
    setIsBooped(true);
  };

  return (
    <animated.span
      onMouseEnter={trigger}
      style={{
        ...style,
        display: 'inline-block',
        backfaceVisibility: 'hidden',
      }}
    >
      {children}
    </animated.span>
  );
};

export default Boop;
